var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ver-listado-categorias',{attrs:{"banderaOcultarMas":true,"formulariosMomentosllenos":_vm.formulariosMomentosllenos,"formulariosLlenosTipoMomento":_vm.formulariosLlenosTipoMomento}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62bc4998","hasScoped":true,"buble":{"transforms":{}}}!./src/components/VerListadoEncuentros/VerListadoEncuentros.html
// module id = 884
// module chunks = 0